define('blocks/tariffs/tariffs',['require','../../js/radar','../../js/actions'],function (require) {
    var radar = require('../../js/radar');
    var action = require('../../js/actions');
    var actionId = action.actionId;

    function debounce(f, ms) {
        var isCooldown = false;
        return function () {
            if (isCooldown) return;
            f.apply(this, arguments);
            isCooldown = true;
            setTimeout(function() {isCooldown = false}, ms);
        };
    }

    function toggleAction(isActionTab) {
        var $tariffSection = $('.tariffsSection');
        var actionClass = 'tariffs-action';

        if (isActionTab && !$tariffSection.hasClass(actionClass)) {
            $tariffSection.addClass(actionClass);
            return;
        }

        !isActionTab && $tariffSection.removeClass(actionClass);
    }

    (function () {
        var $tariffBox = $('[data-tariffs]');
        var $actionTab = $tariffBox.find('[data-target=tariffsAction]');

        action.getFeatureAction.then(function (isFeatureAction) {
            var hash = window.location.hash;

            // показываем табы, если включена акция
            if (isFeatureAction) {
                $actionTab.removeClass('-hidden');
                toggleAction(true);

                radar.ga({
                    category: 'cloud_promo_action',
                    action: 'show',
                    label: actionId,
                });

                if (!hash || hash === '#special') {
                    $actionTab.click();
                }
            }
        });

        $tariffBox.on('click', '[data-target]', function (event) {
            var $link = $(this);
            var target = $link.data('target');
            var labelItem = $link.data('label');
            var $content = $tariffBox.find('#' + target);
            var $carousel = $content.find('.owl-carousel');

            toggleAction(target === 'tariffsAction');

            $link.addClass('-active').siblings().removeClass('-active');
            $content.addClass('-active').siblings().removeClass('-active');
            // Update Carousel
            $carousel.data('owl.carousel')._invalidated.width = true;
            $carousel.trigger('refresh.owl.carousel');

            radar.ga({
                category: 'cloud_promo_tariffs',
                action: 'switch',
                label: labelItem,
            });

            if (target === 'tariffsAction') {
                radar.ga({
                    category: 'cloud_promo_action',
                    action: 'click',
                    label: labelItem,
                });
            }

            event.preventDefault();
        });
    })();

    (function () {
        var $slider = $('.tariffs__slider'),
            patternUserAgent = /iPhone|iPod|iPad|iOS|android/i,
            isMobile = !!navigator.userAgent.match(patternUserAgent);

        if ($slider.length) {
            $slider.each(function () {
                var $carousel = $(this);

                var items = $carousel.find('.tariff__item:not(.-hidden)');

                var loop = items.length > 1;

                $carousel.owlCarousel({
                    margin: 20,
                    smartSpeed: 700,
                    loop: loop,
                    center: true,
                    autoWidth: true,
                    startPosition: 0,
                    nav: false,
                    dots: true,
                    mouseDrag: false,
                    responsive: {
                        0: {
                            nav: false,
                            dots: loop,
                        },
                        700: {
                            margin: 10,
                            nav: false,
                            dots: true,
                            items: Math.min( items.length, 2 ),
                            center: Boolean(Math.min( items.length, 2 ) % 2),
                        },
                        1000: {
                            margin: 40,
                            nav: loop,
                            dots: false,
                            items: Math.min( items.length, 2 ),
                            center: Boolean(Math.min( items.length, 2 ) % 2),
                        },
                        1366: {
                            margin: 20,
                            nav: loop,
                            dots: false,
                            items: Math.min( items.length, 3 ),
                            center: Boolean(Math.min( items.length, 3 ) % 2),
                        },
                    },
                });

                const updateCarousel = debounce(function() {
                    $carousel.data('owl.carousel')._invalidated.width = true;
                    $carousel.trigger('refresh.owl.carousel');
                }, 300);

                if (isMobile) {
                    window.addEventListener('orientationchange', updateCarousel, false);
                } else {
                    $(window).resize(updateCarousel);
                }
            });
        }
    })();

    (function () {
        var $tariffTabs = $('.tariff__tabs');

        if (!window.location.hash) {
            return;
        }

        $('.tariff__title')[0].scrollIntoView();

        switch (window.location.hash) {
            case '#month':
                $tariffTabs.find('[data-target=tariffsMonthYear]').click();
                break;
            case '#year':
                $tariffTabs.find('[data-target=tariffsMonthYear]').click();
                break;
            case '#gift':
                $tariffTabs.find('[data-target=tariffsPresent]').click();
                break;
        }
    })();
});

